module.exports = __webpack_public_path__ + "img/02yellow.bb00dc73.gif";